import { useTranslation } from "react-i18next"
import { Monitor, SquarePlay } from "lucide-react"
import { Button } from "@/components/ui/button"
import { typedEnv } from "@/config/typedEnv"

// Placeholder until the real tutorial video ships (Asana 1216745969372727);
// swappable per environment via VITE_HOME_TUTORIAL_VIDEO_URL.
const FALLBACK_TUTORIAL_URL = "https://www.banuba.com"

const openExternal = (url: string) => {
  window.open(url, "_blank", "noopener,noreferrer")
}

export const ExploreSection = () => {
  const { t } = useTranslation()

  const handleLaunchDemo = () => {
    // Env-matched shopper stand (dev/uat/prod tintvto.com).
    openExternal(`https://${typedEnv.VITE_TINT_WIDGET_LINK}`)
  }

  const handleWatchTutorial = () => {
    openExternal(typedEnv.VITE_HOME_TUTORIAL_VIDEO_URL ?? FALLBACK_TUTORIAL_URL)
  }

  return (
    <section className="flex flex-col gap-4" data-testid="home-explore">
      <h2 className="text-base font-semibold">{t("home.explore.title")}</h2>
      <div className="grid gap-4 md:grid-cols-2">
        <div className="flex items-center gap-4 rounded-2xl border-2 border-empty-tile bg-card p-6">
          <span className="flex size-[60px] shrink-0 items-center justify-center rounded-xl bg-orange-100">
            <Monitor className="size-10" strokeWidth={1.5} aria-hidden />
          </span>
          <div className="flex min-w-0 flex-1 flex-col gap-1">
            <h3 className="text-lg font-semibold">{t("home.explore.demoTitle")}</h3>
            <p className="text-sm text-muted-foreground">{t("home.explore.demoSubtitle")}</p>
          </div>
          <Button variant="outline" onClick={handleLaunchDemo} data-testid="home-launch-demo">
            {t("home.explore.demoCta")}
          </Button>
        </div>
        <div className="flex items-center gap-4 rounded-2xl border-2 border-empty-tile bg-card p-6">
          <span className="flex size-[60px] shrink-0 items-center justify-center rounded-xl bg-orange-100">
            <SquarePlay className="size-10" strokeWidth={1.5} aria-hidden />
          </span>
          <div className="flex min-w-0 flex-1 flex-col gap-1">
            <h3 className="text-lg font-semibold">{t("home.explore.tutorialTitle")}</h3>
            <p className="text-sm text-muted-foreground">{t("home.explore.tutorialSubtitle")}</p>
          </div>
          <Button
            variant="outline"
            className="w-[104px]"
            onClick={handleWatchTutorial}
            data-testid="home-watch-tutorial"
          >
            {t("home.explore.tutorialCta")}
          </Button>
        </div>
      </div>
    </section>
  )
}
